import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Admin from '../../store/admin';
import * as App from '../../store/app';

import EditWork, { IProps } from '../../components/admin/EditWork';
import { NotificationType } from '../../models';

type Props =
    Admin.IAdminState &
    App.IAppState &
    IProps;

export default connect(
    (state: ApplicationState) => ({
        constants: state.constants,
        countries: state.constants.countries,
        users: state.admin.users,
        machineryTypes: state.user.machineryTypes,
        notifications: state.notifications.notifications
            .filter(n => n.ctx === 'adminwork' || n.ctx === 'adminworkusers'),
        loadingNotifications: state.notifications.notifications
            .filter(n => n.ctx === 'adminwork' && n.type === NotificationType.LOADING),
        loading: state.app.loading,
        loadingMessage: state.app.loadingMessage
    }),
    Admin.actionCreators,
)(EditWork as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
